export default {
    title: 'Спасибо за покупку',
}
